// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Show a loading spinner or placeholder
  }

  if (!isAuthenticated) {
    console.log("returning to home page");
    return <Navigate to="/" />; // Redirect to the login/signup page if not authenticated
  }

  return children;
};

export default ProtectedRoute;
